import React from 'react'

import { Helmet } from 'react-helmet'

import './about.css'

const About = (props) => {
  return (
    <div className="about-container">
      <Helmet>
        <title>
          About - FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders
        </title>
        <meta
          name="description"
          content="Faith-based non-profit bridging quality education and accessibility. Empowering children through Christ-centered learning, tech literacy &amp; character development"
        />
        <meta
          property="og:title"
          content="About - FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders"
        />
        <meta
          property="og:description"
          content="Bridging quality education and accessibility through Christ-centered learning. Empowering every child to flourish in their unique calling with faith and innovation."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/97765a8c-e132-4703-821d-7a550778f912/2688ccf9-cb16-49f3-aba4-ad25e1010654?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <div className="about-about-us">
        <div className="about-frame12">
          <div className="about-frame141">
            <div className="about-frame162">
              <img
                alt="VectorI316"
                src="/external/vectori316-jj7e.svg"
                className="about-vector10"
              />
              <span className="about-text10">futureheirs</span>
            </div>
            <div className="about-frame81">
              <div className="about-frame6">
                <span className="about-text11">Home</span>
              </div>
              <div className="about-frame7">
                <span className="about-text12">About Us</span>
              </div>
              <div className="about-frame82">
                <span className="about-text13">Contact Us</span>
              </div>
              <div className="about-frame9">
                <span className="about-text14">Blog</span>
              </div>
            </div>
            <div className="about-component41">
              <span className="about-text15">Join Us</span>
            </div>
          </div>
          <div className="about-frame13">
            <div className="about-frame195">
              <img
                alt="Line653163"
                src="/external/line653163-k1ym.svg"
                className="about-line65"
              />
              <span className="about-text16">About Us</span>
            </div>
            <span className="about-text17">
              Discover our mission, values, and the impact we’re making in
              education and technology.
            </span>
          </div>
        </div>
        <img
          alt="Rectangle43163"
          src="/external/rectangle43163-xbsr.svg"
          className="about-rectangle41"
        />
        <div className="about-frame3028">
          <div className="about-frame145">
            <div className="about-frame144">
              <img
                alt="Rectangle43163"
                src="/external/rectangle43163-zm85-300h.png"
                className="about-rectangle42"
              />
              <div className="about-frame171">
                <div className="about-frame21">
                  <span className="about-text18">Who We Are</span>
                </div>
                <span className="about-text19">
                  FutureHeirs is a faith-based non-profit organization founded
                  on the belief that every child deserves the opportunity to
                  flourish in their unique calling. We bridge the gap between
                  quality education and accessibility, preparing young minds to
                  lead with integrity, innovate with purpose, and serve with
                  compassion.
                </span>
              </div>
            </div>
            <div className="about-frame143">
              <div className="about-frame16">
                <div className="about-frame191">
                  <div className="about-group39">
                    <img
                      alt="Ellipse13163"
                      src="/external/ellipse13163-ynis-200h.png"
                      className="about-ellipse11"
                    />
                    <img
                      alt="puzzlepiece6svgrepocom13163"
                      src="/external/puzzlepiece6svgrepocom13163-qxz9.svg"
                      className="about-puzzlepiece6svgrepocom1"
                    />
                  </div>
                  <span className="about-text20">Our Purpose</span>
                </div>
                <span className="about-text21">
                  FutureHeirs exists to bridge the gap between quality education
                  and accessibility, ensuring every child flourishes in their
                  unique calling.
                </span>
              </div>
              <div className="about-frame142">
                <div className="about-frame18">
                  <div className="about-group381">
                    <img
                      alt="Ellipse13163"
                      src="/external/ellipse13163-stnc-200h.png"
                      className="about-ellipse12"
                    />
                    <img
                      alt="book2svgrepocom13163"
                      src="/external/book2svgrepocom13163-fmcr.svg"
                      className="about-book2svgrepocom1"
                    />
                  </div>
                  <span className="about-text22">Our Vision</span>
                </div>
                <span className="about-text23">
                  A world where every child receives transformative education,
                  blending faith and innovation to inspire future leaders who
                  drive positive change.
                </span>
              </div>
              <div className="about-frame172">
                <div className="about-frame192">
                  <div className="about-group382">
                    <img
                      alt="Ellipse13163"
                      src="/external/ellipse13163-z3v-200h.png"
                      className="about-ellipse13"
                    />
                    <img
                      alt="targetsvgrepocom13163"
                      src="/external/targetsvgrepocom13163-zz9.svg"
                      className="about-targetsvgrepocom1"
                    />
                  </div>
                  <span className="about-text24">Our Mission</span>
                </div>
                <span className="about-text25">
                  Empowering future leaders through Christ-centered education,
                  tech literacy, and character development to fulfill their
                  God-given potential.
                </span>
              </div>
            </div>
          </div>
          <div className="about-frame3010">
            <span className="about-text26">Our Core Values</span>
            <div className="about-frame3009">
              <div className="about-frame3007">
                <div className="about-frame2990">
                  <span className="about-text27">Faith-Centered Approach</span>
                  <span className="about-text28">
                    We ground our work in Christian principles, celebrating
                    God&apos;s unique design for each child.
                  </span>
                </div>
                <div className="about-frame2994">
                  <span className="about-text29">Whole-Child Development</span>
                  <span className="about-text30">
                    We nurture intellectual, spiritual, emotional, and social
                    growth in equal measure.
                  </span>
                </div>
              </div>
              <div className="about-frame2991">
                <span className="about-text31">
                  Excellence Without Exclusion
                </span>
                <span className="about-text32">
                  We pursue the highest standards while ensuring our programs
                  remain accessible to all.
                </span>
              </div>
              <div className="about-frame3008">
                <div className="about-frame2995">
                  <span className="about-text33">Servant Leadership</span>
                  <span className="about-text34">
                    We model and cultivate leadership that prioritizes the needs
                    of others.
                  </span>
                </div>
                <div className="about-frame2992">
                  <span className="about-text35">Innovative Thinking</span>
                  <span className="about-text36">
                    We embrace creative solutions that prepare students for a
                    rapidly evolving future.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="about-component5">
            <div className="about-frame140">
              <span className="about-text37">Our Programs</span>
              <div className="about-frame131">
                <img
                  alt="Frame130I321"
                  src="/external/frame130i321-byb5.svg"
                  className="about-frame130"
                />
                <img
                  alt="Frame109I321"
                  src="/external/frame109i321-uzq8.svg"
                  className="about-frame109"
                />
              </div>
            </div>
            <div className="about-frame139">
              <div className="about-frame135">
                <img
                  alt="Rectangle3I321"
                  src="/external/rectangle3i321-1f8-200h.png"
                  className="about-rectangle31"
                />
                <div className="about-frame1341">
                  <span className="about-text38">Online Learning Academy</span>
                  <span className="about-text39">
                    Our digital platform makes quality, faith-integrated
                    education...
                  </span>
                </div>
                <div className="about-component42">
                  <span className="about-text40">Learn more</span>
                </div>
              </div>
              <div className="about-frame138">
                <img
                  alt="Rectangle3I321"
                  src="/external/rectangle3i321-5wg6-200h.png"
                  className="about-rectangle32"
                />
                <div className="about-frame1342">
                  <span className="about-text41">Tech Innovation Centers</span>
                  <span className="about-text42">
                    Hands-on learning spaces where students develop practical...
                  </span>
                </div>
                <div className="about-component43">
                  <span className="about-text43">Learn more</span>
                </div>
              </div>
              <div className="about-frame137">
                <img
                  alt="Rectangle3I321"
                  src="/external/rectangle3i321-nl6-200h.png"
                  className="about-rectangle33"
                />
                <div className="about-frame1343">
                  <span className="about-text44">Community Learning Hubs</span>
                  <span className="about-text45">
                    Physical spaces within underserved communities...
                  </span>
                </div>
                <div className="about-component44">
                  <span className="about-text46">Learn more</span>
                </div>
              </div>
              <div className="about-frame136">
                <img
                  alt="Rectangle3I321"
                  src="/external/rectangle3i321-wc43-200h.png"
                  className="about-rectangle34"
                />
                <div className="about-frame1344">
                  <span className="about-text47">Leadership Development</span>
                  <span className="about-text48">
                    Beyond academics and technical skills, we invest in
                    cultivating...
                  </span>
                </div>
                <div className="about-component45">
                  <span className="about-text49">Learn more</span>
                </div>
              </div>
            </div>
          </div>
          <div className="about-frame3023">
            <div className="about-frame3029">
              <span className="about-text50">Our Impact</span>
              <span className="about-text51">
                Numbers tell only part of our story. The true measure of our
                impact lies in the transformed lives of children who discover
                their purpose, develop their gifts, and go on to create positive
                change in their families, communities, and beyond.
              </span>
            </div>
            <div className="about-frame3021">
              <div className="about-frame3018">
                <div className="about-frame3011">
                  <img
                    alt="userssvgrepocom13241"
                    src="/external/userssvgrepocom13241-5wpe.svg"
                    className="about-userssvgrepocom1"
                  />
                  <span className="about-text52">5,000+</span>
                  <span className="about-text53">
                    Students Served Across 27 States
                  </span>
                </div>
                <div className="about-frame3014">
                  <img
                    alt="laptopcodesvgrepocom13241"
                    src="/external/laptopcodesvgrepocom13241-5l3m.svg"
                    className="about-laptopcodesvgrepocom1"
                  />
                  <span className="about-text54">3,200</span>
                  <span className="about-text55">
                    Students Trained in Technology
                  </span>
                </div>
                <div className="about-frame3017">
                  <img
                    alt="universitysvgrepocom13241"
                    src="/external/universitysvgrepocom13241-3hx9.svg"
                    className="about-universitysvgrepocom1"
                  />
                  <span className="about-text56">1,200+</span>
                  <span className="about-text57">
                    University Students &amp; Graduates Trained
                  </span>
                </div>
              </div>
              <div className="about-frame3019">
                <div className="about-frame3012">
                  <img
                    alt="schoolsvgrepocom13241"
                    src="/external/schoolsvgrepocom13241-mil.svg"
                    className="about-schoolsvgrepocom11"
                  />
                  <span className="about-text58">15</span>
                  <span className="about-text59">
                    Community Learning Hubs Established
                  </span>
                </div>
                <div className="about-frame3015">
                  <img
                    alt="churchsvgrepocom13241"
                    src="/external/churchsvgrepocom13241-w2nue.svg"
                    className="about-churchsvgrepocom1"
                  />
                  <span className="about-text60">120</span>
                  <span className="about-text61">
                    Church &amp; Community Partnerships
                  </span>
                </div>
              </div>
              <div className="about-frame3020">
                <div className="about-frame3013">
                  <img
                    alt="graduationcapsvgrepocom13241"
                    src="/external/graduationcapsvgrepocom13241-ouco.svg"
                    className="about-graduationcapsvgrepocom1"
                  />
                  <span className="about-text62">750</span>
                  <span className="about-text63">
                    Graduates from Leadership Program
                  </span>
                </div>
                <div className="about-frame3016">
                  <img
                    alt="schoolsvgrepocom13241"
                    src="/external/schoolsvgrepocom13241-o9l9.svg"
                    className="about-schoolsvgrepocom12"
                  />
                  <span className="about-text64">45</span>
                  <span className="about-text65">
                    High Schools Collaborated With
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="about-frame3027">
            <div className="about-frame3026">
              <div className="about-frame3025">
                <img
                  alt="Ellipse1813361"
                  src="/external/ellipse1813361-77qb-500h.png"
                  className="about-ellipse181"
                />
                <img
                  alt="Ellipse1833361"
                  src="/external/ellipse1833361-3ka6-400h.png"
                  className="about-ellipse183"
                />
                <img
                  alt="Vector3361"
                  src="/external/vector3361-8jy5.svg"
                  className="about-vector11"
                />
                <div className="about-group126">
                  <div className="about-maskgroup">
                    <img
                      alt="Ellipse1843361"
                      src="/external/ellipse1843361-gjhr-500h.png"
                      className="about-ellipse184"
                    />
                    <img
                      alt="portraitafricanamericanmodel13361"
                      src="/external/portraitafricanamericanmodel13361-7w29-500h.png"
                      className="about-portraitafricanamericanmodel1"
                    />
                  </div>
                  <img
                    alt="portraitafricanamericanmodel23361"
                    src="/external/portraitafricanamericanmodel23361-k20g-400w.png"
                    className="about-portraitafricanamericanmodel2"
                  />
                </div>
                <div className="about-frame1611">
                  <img
                    alt="Vector3361"
                    src="/external/vector3361-6vdg.svg"
                    className="about-vector12"
                  />
                  <span className="about-text66">futureheirs</span>
                </div>
              </div>
              <div className="about-frame218">
                <span className="about-text67">Join Our Mission</span>
                <span className="about-text68">
                  <span>
                    The work of FutureHeirs is made possible through the
                    generosity and involvement of people who share our passion
                    for empowering the next generation. Whether through
                    financial support, volunteer service, or prayer, your
                    partnership makes a difference in the lives of children
                    discovering their God-given potential.
                  </span>
                  <br></br>
                  <span>
                    Together, we can build a future where every child has the
                    opportunity to flourish where education transcends barriers
                    and inspires young leaders who will shape tomorrow with
                    wisdom, innovation, and faith.
                  </span>
                  <br></br>
                </span>
              </div>
            </div>
            <div className="about-frame189">
              <div className="about-frame184">
                <div className="about-group107">
                  <span className="about-text73">Company</span>
                  <div className="about-frame2491">
                    <span className="about-text74">Home</span>
                    <span className="about-text75">About Us</span>
                    <span className="about-text76">Contact Us</span>
                    <span className="about-text77">Programs</span>
                    <span className="about-text78">Approach</span>
                  </div>
                </div>
                <div className="about-group106">
                  <span className="about-text79">Quick Links</span>
                  <div className="about-frame2492">
                    <span className="about-text80">Partner with Us</span>
                    <span className="about-text81">Volunteer</span>
                    <span className="about-text82">Donate</span>
                    <span className="about-text83">Blog</span>
                  </div>
                </div>
                <div className="about-group105">
                  <span className="about-text84">Terms and Policies</span>
                  <div className="about-frame248">
                    <span className="about-text85">Privacy Policy</span>
                    <span className="about-text86">Terms and Conditions</span>
                    <span className="about-text87">Feedback</span>
                    <span className="about-text88">FAQs</span>
                  </div>
                </div>
                <div className="about-group104">
                  <span className="about-text89">Contact Information</span>
                  <div className="about-group87">
                    <span className="about-text90">
                      connect@futureheirs.org
                    </span>
                    <div className="about-vuesaxboldsms1">
                      <div className="about-vuesaxboldsms2">
                        <div className="about-sms">
                          <img
                            alt="VectorI336"
                            src="/external/vectori336-b9ml.svg"
                            className="about-vector13"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="about-group88">
                    <span className="about-text91">
                      123 Faith &amp; Innovation Way, Your City, State 12345
                    </span>
                    <div className="about-vuesaxboldlocation1">
                      <div className="about-vuesaxboldlocation2">
                        <img
                          alt="VectorI336"
                          src="/external/vectori336-p3v.svg"
                          className="about-vector14"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="about-group89">
                    <span className="about-text92">(555) 123-4567</span>
                    <div className="about-vuesaxboldcall1">
                      <div className="about-vuesaxboldcall2">
                        <div className="about-call">
                          <img
                            alt="VectorI336"
                            src="/external/vectori336-1ahk.svg"
                            className="about-vector15"
                          />
                          <img
                            alt="VectorI336"
                            src="/external/vectori336-e0io.svg"
                            className="about-vector16"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <img
                alt="Line2I336"
                src="/external/line2i336-u8xm.svg"
                className="about-line2"
              />
              <div className="about-frame183">
                <div className="about-frame1612">
                  <img
                    alt="VectorI336"
                    src="/external/vectori336-t9ua.svg"
                    className="about-vector17"
                  />
                  <span className="about-text93">futureheirs</span>
                </div>
                <div className="about-frame180">
                  <span className="about-text94">Follow Us:</span>
                  <div className="about-frame177">
                    <div className="about-vuesaxboldfacebook1">
                      <div className="about-vuesaxboldfacebook2">
                        <div className="about-facebook">
                          <img
                            alt="VectorI336"
                            src="/external/vectori336-ep5c.svg"
                            className="about-vector18"
                          />
                        </div>
                      </div>
                    </div>
                    <img
                      alt="riinstagramfillI336"
                      src="/external/riinstagramfilli336-bzx.svg"
                      className="about-riinstagramfill"
                    />
                    <img
                      alt="pajamaslinkedinI336"
                      src="/external/pajamaslinkedini336-6rs.svg"
                      className="about-pajamaslinkedin"
                    />
                    <img
                      alt="fa6brandssquarextwitterI336"
                      src="/external/fa6brandssquarextwitteri336-mbj.svg"
                      className="about-fa6brandssquarextwitter"
                    />
                    <div className="about-vuesaxboldyoutube1">
                      <div className="about-vuesaxboldyoutube2">
                        <div className="about-youtube">
                          <img
                            alt="VectorI336"
                            src="/external/vectori336-egh.svg"
                            className="about-vector19"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
